// 获取URL查询参数
export const getQuery = key => {
    let value = '';

    try {
        const urlObj = new URL(location.href);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

// 时间戳获取年月日时分秒
export const getDateTime = timestamp => {
    const date = new Date(Number(timestamp) * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    // const second = date.getSeconds();

    return {
        yearMonthDay: `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`,
        hourMinute: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
    };
};

// 链接地址host获取
export const getJumpUrlHost = platform => {
    let urlHost = `http://${location.host}/${platform}/finance`;

    /* eslint-disable */
    switch (NODE_ENV) {
        case 'staging':
            urlHost = 'http://test.finance.ifeng.com';
            break;
        case 'production':
            urlHost = 'https://finance.ifeng.com';

            break;
        default:
            urlHost = `http://${location.host}/${platform}/finance`;

            break;
    }
    /* eslint-enable */

    return urlHost;
};
